import { memo } from 'react'

import { useFlexOffers } from '@cox/core-ui8/dist/useFlexOffers'

import { CarouselSlideProps } from './types'
import { DynamicMediaComponents, getDynamicMediaFromSrc } from '../../../../utils/dynamic-media-util'
import { getAttributeValue, getConditionResult, hasCFConditionals } from '../../../../utils/rule-builder-util'
import { RuleType } from '../../../../utils/types'
import ReactImage from '../../../ReactImage'

const CarouselSlide = (props: CarouselSlideProps) => {
  const { ruleExpression = '', tokenProperties, carouselSlideIndex, condition, activeItem, elements, id, ruleType } = props
  const flexOffers = useFlexOffers(ruleExpression)
  const { image, imageParams, altImage } = elements

  // get value if it is dynamic, or else return value authored value
  const getValue = (attribute: any, propertyName?: string) => {
    if (hasCFConditionals(attribute)) {
      const jsonAttribute = (props as any)?.[`${propertyName}_json`]
      return getAttributeValue(jsonAttribute, flexOffers, carouselSlideIndex, tokenProperties, propertyName)
    }
    return getAttributeValue(attribute, flexOffers, carouselSlideIndex, tokenProperties, propertyName)
  }
  // flex offers success
  let conditionResult = true
  if (flexOffers?.success && ruleType === RuleType.conditional && condition) {
    conditionResult = getConditionResult(condition, flexOffers)
  }
  if (conditionResult) {
    const altImageValue = getValue(altImage, 'altImage')
    const imageParamsValue = getValue(imageParams, 'imageParams')
    const imageValue = getDynamicMediaFromSrc(
      getValue(image, 'image') as string,
      (imageParamsValue as DynamicMediaComponents) || DynamicMediaComponents.CAROUSEL_IMAGERY
    )

    return (
      <div className={`carousel-slide ${activeItem === id ? 'show' : 'hide'}`}>
        <ReactImage alt={altImageValue} src={imageValue} />
      </div>
    )
  }
  return <></>
}

export default memo(CarouselSlide)
